export const handleIsValidAddressCheckout = (address) => {
  if (!address) return;
  if (!address.zipCode?.value) return;
  if (!address.street?.value) return;
  if (!address.number?.value) return;
  if (!address.district?.value) return;
  if (!address.city?.value) return;
  if (!address.state?.value) return;
  return true;
};
